// const BASE_URL = "http://localhost:52001/api/v1";
const BASE_URL = "https://uat.api.unboxedgifts.in/api/v1";

export const endpoints = {
  login: `${BASE_URL}/admin/auth/login`,
  pincode: `${BASE_URL}/admin/admin/pincodes`,
  createUser: `${BASE_URL}/admin/user/create`,
  allUsers: `${BASE_URL}/admin/user/get_user`,
  getAllCategory: `${BASE_URL}/admin/category/get_all`,
  createCategory: `${BASE_URL}/admin/category/create`,
  createAttribute: `${BASE_URL}/admin/admin/attribute/create`,
  getAllAttributes: `${BASE_URL}/admin/admin/attribute/get_all`,
  createProductType: `${BASE_URL}/admin/admin//productType/create`,
  getAllProductType: `${BASE_URL}/admin/admin/productType/get_all`,
  createProduct: `${BASE_URL}/admin/product/create`,
  getAllProducts: `${BASE_URL}/admin/product/list`,
  deleteProduct: `${BASE_URL}/admin/product/delete`,
  deleteCategory: `${BASE_URL}/admin/category/delete`,
  addSlider: `${BASE_URL}/admin/admin/addSlider`,
};
